import React from "react";

const Avatar = ({ name = "", avatar = null }) => {
    if (name !== null && name !== "" && !name.includes("undefined")) {
        name = decodeURIComponent(name);        
        let avatarName = (name.match(/\b(\w)/g) !== null) ? name.match(/\b(\w)/g).join('') : "-";        
        let bgClass = "bg-success";
        let dangerAlphabet = "afkpuz";
        let infoAlphabet = "bglqv";
        let primaryAlphabet = "chmrw";
        let warningAlphabet = "dinsx";
        let avatarChar = avatarName.charAt(0).toLowerCase();
        if (dangerAlphabet.includes(avatarChar)) {
            bgClass = "bg-danger"
        } else if (infoAlphabet.includes(avatarChar)) {
            bgClass = "bg-info"
        } else if (primaryAlphabet.includes(avatarChar)) {
            bgClass = "bg-primary"
        } else if (warningAlphabet.includes(avatarChar)) {
            bgClass = "bg-warning"
        }
        return (
            <>
                {!avatar && <Avatar {...avatarName} />}
                {avatar && <Avatar />}
            </>
        )
    } else {
        return (
            <>
                <div>-</div>
            </>
        )
    }
}

export default Avatar;